/* eslint-disable jsx-a11y/label-has-for */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const TermsAndConditionsInput = React.forwardRef(
    ({ value, onChange, onClick }, ref) => {
        const { t } = useTranslation('customer');
        return (
            <div className="m2g-customer-terms-and-conditions-message">
                <input
                    id="m2g-customer-terms-and-conditions-checkbox"
                    data-terms-and-conditions-checkbox
                    type="checkbox"
                    className="m2g-input"
                    checked={value}
                    onChange={e => onChange(e.target.checked)}
                    ref={ref}
                />
                <label
                    htmlFor="m2g-customer-terms-and-conditions-checkbox"
                    data-terms-and-conditions-message-label
                    className="m2g-customer-terms-and-conditions-label"
                >
                    <span>{t('i_agree_to')}</span>
                    <span
                        data-terms-and-conditions-link
                        className="m2g-customer-terms-and-conditions-link m2g-text--link"
                        onClick={e => {
                            e.stopPropagation();
                            e.preventDefault(); 
                            onClick(e);
                        }}
                        onKeyPress={() => {}}
                        tabIndex={0}
                        role="link"
                    >
                        {t('terms_and_conditions')}
                    </span>
                </label>
            </div>
        );
    }
);

TermsAndConditionsInput.propTypes = {
    value: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
};

export default TermsAndConditionsInput;
